import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { DiscordProvider } from './client/context/DiscordContext';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <DiscordProvider>
      <App />
    </DiscordProvider>
  </StrictMode>,
);
